import type { ButtonProps } from "@mui/material";
import { Button, styled } from "@mui/material";
import type { NavLinkProps } from "react-router";
import { NavLink } from "react-router";

type NavButtonProps = ButtonProps & Partial<Pick<NavLinkProps, "to" | "end">>;

export const NavButton = styled(({ to, end, ...rest }: NavButtonProps) => {
  if (to !== undefined) {
    return <Button component={NavLink} to={to} end={end} {...rest} />;
  }
  return <Button {...rest} />;
})(({ theme }) => ({
  color: "var(--modus-wc-color-white)",
  height: 56,
  borderBottom: "4px solid transparent",
  fontWeight: 600,
  fontSize: 14,
  borderRadius: 0,
  "&:hover, &[aria-expanded='true']": {
    borderBottomColor: "var(--modus-wc-color-white)",
  },
  "&.active": {
    borderBottomColor: theme.palette.secondary.main,
  },
}));
